module.exports = {
  "id": "mushroom",
  "title": "mushroom",
  "image": "provision/parts/mushroom/mushroom.png",
  "info": [
    {
      "text": "Add a mushroom to your project",
      "image": "provision/parts/mushroom/mushroom.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/mushroom/mushroom.png"
};